export function getURLWaymenu(urlPagina, baseURL) {
  if (!urlPagina) {
    return "";
  }
  let urlWaymenu = null;

  if (urlPagina.includes("erpdev_react")) {
    urlWaymenu = "http://waymenudev_react.waybe.com.br:3001";
  } else if (urlPagina.includes("erphomologqa_react")) {
    urlWaymenu = "http://waymenuhomologqa_react.waybe.com.br:3002";
  } else if (urlPagina.includes("erphomolog_react")) {
    urlWaymenu = "http://waymenuhomolog_react.waybe.com.br:3003";
  } else if (urlPagina.includes("erp.waybe")) {
    urlWaymenu = "https://waymenu.waybe.com.br";
  } else if (urlPagina.includes("localhost")) {
    urlWaymenu = `${tratarBaseURL(baseURL)}:5173`;
  }
  return urlWaymenu;
}

function tratarBaseURL(baseURL) {
  const index = baseURL.lastIndexOf(":");
  if (index !== -1) {
    return baseURL.substring(0, index);
  }
  return baseURL;
}
